import LoaderOverlay from "@edaz/edazkit/LoaderOverlay/index";
import React from "react";
import { preventDefault } from "@frui.ts/views";
import Button from "@edaz/edazkit/Button/index";
import type { ViewComponent } from "@frui.ts/views/dist";
import { registerView } from "@frui.ts/views/dist";
import { observer } from "mobx-react-lite";
import { ButtonToolbar, Form } from "react-bootstrap";
import UserEditationViewModel from "viewModels/users/users/userEditationViewModel";
import UserForm from "./userForm";

export const UserEditationView: ViewComponent<UserEditationViewModel> = observer(({ vm }) => {
  return (
    <LoaderOverlay loading={vm.busyWatcher.isBusy}>
      <h4 className="mt-4">{vm.name}</h4>
      <Form onSubmit={preventDefault(vm.save)}>
        <UserForm vm={vm} />
        {vm.allowWrite && (
          <ButtonToolbar className="justify-content-center">
            <Button size="sm" type="submit" disabled={vm.busyWatcher.isBusy}>
              {vm.translateGeneral("save")}
            </Button>
          </ButtonToolbar>
        )}
      </Form>
    </LoaderOverlay>
  );
});

registerView(UserEditationView, UserEditationViewModel);
